import React, { useState } from "react";
import "./style.scss";
import { AlertAccount, CustomButton, FundList } from "../../components";
import { dataLayerGTM } from "../../utils/functions/dataLayerGTM";
import {
  setIvestMinAmount,
  setSelectedFundCust,
  sendFundsCode,
  createFundV2,
} from "./redux/action";
import { compose } from "underscore";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { setCustFundDetail } from "../fundDetails/redux/action";
import { determineFundRisk } from "../../utils/functions/determineFundRisk";
import { showError } from "../../globalRedux/actions";

const tabs = ["conservative", "moderate", "aggressive"];

function FundSelectionList(props) {
  const {
    setIvestMinAmount,
    setSelectedFundCust,
    customerPortfolio,
    setCustFundDetail,
    scoreList,
    sendFundsCode,
    history,
    createFundV2,
    createFundLoadingV2,
    currentTab,
    funds,
    fundList,
    riskProfileResult,
    masterId,
    showError
  } = props;

  const [selectedFunds, setSelectedFunds] = useState({
    code: "",
    name: "",
    salesCharge: "",
    serviceTaxPerc: ""
  });

  const [show, setShow] = useState({
    fundChangeAlert: false,
    fundInfo: false,
  });

  const handleSelect = val => () => {
    let { code, name, salesFeePerc: salesCharge, serviceTaxPerc } = val;
    dataLayerGTM("click_tag", "Click", "Button", `Fund ${name} - Select`);

    const fund = fundList.find(item => item.code === code) || {};
    const customerFund =
      customerPortfolio.find(item => item.fundCd === code) || {};
    const fundPayload = { code, name, salesCharge, serviceTaxPerc };

    setIvestMinAmount(fund.minSubsAmt);
    setSelectedFundCust(val);
    setSelectedFunds(fundPayload);
    setCustFundDetail(customerFund);

    const fundRisk = determineFundRisk({
      codeRange: fund.riskProfileCode,
      currentCodeRange: riskProfileResult.result,
      scoreList,
    });

    if (!fundRisk) {
      return showError(
        "We are facing some technical issue, we're sorry for the inconvenience."
      );
    }
    if (fundRisk === "HIGH_RISK") {
      setShow(prev => ({ ...prev, fundChangeAlert: true }));
    } else {
      handleNext(fundPayload);
    }
  };

  const handleNext = fundsCode => {
    // forbid user from creating portfolio twice on rapid/double click
    if (createFundLoadingV2) return;

    sendFundsCode([fundsCode]);

    createFundV2(
      {
        cifId: masterId,
        fundsPayload: [{ fundCode: fundsCode.code }],
      },
      () => {
        // redux-saga action still running(not finished request yet) when user click back button
        // so when user click the button they'll go to dashboard instead of fund selection step 1
        // why go to the dashboard?, because at the moment when user click back they're still in the fund selection step 1
        // here's the illustration of browser history -> ["dashboard", "fund-selection"] -> user click back -> ["dashboard"]
        // in the dashboard there's useeffect with bunch of reset state, see line 117
        // and then when user finish the create portfolio, this callback is running meaning they go to fund selection step 2
        // this is where the error happen because now the `fundsCode` array becomes empty

        if (!history.location.pathname.includes("fund-selection")) return;
        //! important: redux-saga action is running at the top of the react tree, so when react unmounted component/page inside the redux-saga context
        //! (See Provider component at root index.js line 45), they'll still running eventhough the current page that running the sideffects is already unmounted
        //! usually when component/page unmounted the expected behaviour is for all side effects in that component/page cease to exist, ie: gone reduce to atom
        //! that's why useEffect have cleanup function to prevent something like this
        //! why dont use useEffect to cleanup this race condition?
        //! too much work that's why, we need to add guard in the saga with risked of affecting other page, ie: switching page

        history.push("/fund-selection-step-two");
      }
    );
  };

  return (
    <>
      <AlertAccount
        title="You’ve selected a fund which does not match your risk profile. Do you wish to continue?"
        firstText="The fund you have selected does not match your risk profile. If you wish to continue, please note on the additional risk you might be exposed to."
        isOpen={show.fundChangeAlert}
        hideDoneButton
        firstTextDialogStyle={{ marginTop: "0.5rem", paddingBottom: "0" }}
        handleClose={() =>
          setShow(prev => ({ ...prev, fundChangeAlert: false }))
        }
        titleStyle={{
          fontSize: "1.25rem",
          fontWeight: "700",
          lineHeight: "28px",
        }}
        testId="invest-higher-fund-warning"
      >
        <div>
          <CustomButton
            variant="contained"
            text="Yes, Continue"
            color="#fff"
            backgroundColor="#1278CC"
            onClick={() => handleNext(selectedFunds)}
            testId="continue-invest-higher-fund"
          />
          <CustomButton
            variant="contained"
            text="Maybe other fund"
            color="#1278CC"
            backgroundColor="transparent"
            onClick={() =>
              setShow(prev => ({ ...prev, fundChangeAlert: false }))
            }
            style={{ boxShadow: "none", marginTop: "0.5rem" }}
          />
        </div>
      </AlertAccount>
      <FundList
        currentTab={currentTab}
        tabs={tabs}
        funds={funds[currentTab] || funds["conservative"]}
        handleSelect={handleSelect}
        productType="invest"
      />
    </>
  );
}

const withConnect = connect(
  state => ({
    scoreList: state.fundSelectionReducer.scoreList,
    customerPortfolio: state.dashboardReducer.customerPortfolio,
    masterId: state.goal.profile.masterId,
    createFundLoadingV2: state.fundSelectionReducer.createFundLoadingV2
  }),
  {
    setIvestMinAmount,
    setSelectedFundCust,
    setCustFundDetail,
    sendFundsCode,
    createFundV2,
    showError,
  }
);

export default compose(
  withRouter,
  withConnect
)(FundSelectionList);
